// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#map {
  position: absolute;
  width: 100%;
  height: 100%;
}

ion-content {
  background: var(--ion-color-gray-light);
}

ion-content > ion-col {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.top-bar {
  min-height: 56px;
}

.mode-wrapper {
  position: absolute;
  right: 0;
  top: 0;
  z-index: 10;
}

.venues .title {
  display: none;
  font-size: 21px;
  line-height: 21px;
  margin: 12px 0 24px;
}
@media (min-width: 991px) {
  .venues .title {
    display: block;
  }
}
@media (min-width: 991px) {
  .venues {
    width: 100%;
  }
}

.mode-icon {
  background: white;
  color: #B0BDC8;
  width: 25px;
  height: 25px;
  transition: 0.3s linear;
  padding: 8px;
}

.mode-icon.selected {
  background: var(--ion-color-second);
  color: white;
  transition: 0.3s linear;
}

.venue-list {
  width: 100%;
}

.view-picker {
  margin-bottom: 0;
}

.align-bottom {
  position: absolute;
  max-height: 40vh;
  bottom: 0;
  overflow: auto;
}
@media (min-width: 991px) {
  .align-bottom {
    position: relative;
    bottom: unset;
    max-height: unset;
    height: 100%;
    overflow: auto;
  }
}

@media (min-width: 991px) {
  .full-height-overflow {
    position: relative;
    bottom: unset;
    max-height: unset;
    height: 100%;
    overflow: auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/venue/venue.page.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AADF;;AAIA;EACE,uCAAA;AADF;;AAIA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;AADF;;AAIA;EACE,gBAAA;AADF;;AAIA;EACE,kBAAA;EACA,QAAA;EACA,MAAA;EACA,WAAA;AADF;;AAME;EACE,aAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AAHJ;AC/BE;ED8BA;IAMI,cAAA;EADJ;AACF;ACpCE;ED4BF;IAaI,WAAA;EADF;AACF;;AAIA;EACE,iBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;AADF;;AAIA;EACE,mCAAA;EACA,YAAA;EACA,uBAAA;AADF;;AAIA;EACE,WAAA;AADF;;AAIA;EACE,gBAAA;AADF;;AAIA;EACE,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,cAAA;AADF;ACvEE;EDoEF;IAMI,kBAAA;IACA,aAAA;IACA,iBAAA;IACA,YAAA;IACA,cAAA;EACF;AACF;;AChFE;EDkFF;IAEI,kBAAA;IACA,aAAA;IACA,iBAAA;IACA,YAAA;IACA,cAAA;EACF;AACF","sourcesContent":["@import \"../../../theme/mixins\";\n\n#map {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n}\n\nion-content {\n  background: var(--ion-color-gray-light);\n}\n\nion-content > ion-col {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.top-bar {\n  min-height: 56px;\n}\n\n.mode-wrapper {\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 10;\n}\n\n.venues {\n\n  .title {\n    display: none;\n    font-size: 21px;\n    line-height: 21px;\n    margin: 12px 0 24px;\n    @include desktop {\n      display: block;\n    }\n  }\n\n  @include desktop {\n    width: 100%;\n  }\n}\n\n.mode-icon {\n  background: white;\n  color: #B0BDC8;\n  width: 25px;\n  height: 25px;\n  transition: 0.3s linear;\n  padding: 8px;\n}\n\n.mode-icon.selected {\n  background: var(--ion-color-second);\n  color: white;\n  transition: 0.3s linear;\n}\n\n.venue-list {\n  width: 100%;\n}\n\n.view-picker {\n  margin-bottom: 0;\n}\n\n.align-bottom {\n  position: absolute;\n  max-height: 40vh;\n  bottom: 0;\n  overflow: auto;\n  @include desktop {\n    position: relative;\n    bottom: unset;\n    max-height: unset;\n    height: 100%;\n    overflow: auto;\n  }\n}\n\n.full-height-overflow {\n  @include desktop {\n    position: relative;\n    bottom: unset;\n    max-height: unset;\n    height: 100%;\n    overflow: auto;\n  }\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
